import React from 'react'
import StudentInstruction from '../../Components/StudentInstruction'
import Microphone from '../../Components/PreCheckIllustrations/Microphone'

export default React.memo(function TeacherTestPrompt({ handleRetry }) {

    return <StudentInstruction>
        <h2>Please put on the student's headset and help me make sure I can hear you read.</h2>
        <Microphone/>
        <button onClick={handleRetry}>Test Now</button>
    </StudentInstruction>
})
